export const myCommunity = {
  // Page titles and navigation
  'backoffice.myCommunity.genealogyTreeTitle': 'Stammbaum',
  'backoffice.myCommunity.organizationalChart': 'Organisationsdiagramm',
  'backoffice.myCommunity.treeViewTitle': 'Baumansicht',
  'backoffice.myCommunity.membersTitle': 'Community-Mitglieder',
  'backoffice.myCommunity.genealogyTreeSubtitle': 'Erkunden Sie Ihre vollständige Empfehlungshierarchie',
  'backoffice.myCommunity.treeViewSubtitle': 'Tabellenansicht deiner Community',
  'backoffice.myCommunity.membersSubtitle': 'Liste aller Ihrer direkten und indirekten Empfehlungen',

  // Common labels
  'backoffice.myCommunity.username': 'Benutzername',
  'backoffice.myCommunity.status': 'Status',
  'backoffice.myCommunity.rank': 'Rang',
  'backoffice.myCommunity.level': 'Ebene',
  'backoffice.myCommunity.joinDate': 'Beitrittsdatum',
  'backoffice.myCommunity.country': 'Land',
  'backoffice.myCommunity.active': 'Aktiv',
  'backoffice.myCommunity.inactive': 'Inaktiv',
  'backoffice.myCommunity.loading': 'Wird geladen...',
  'backoffice.myCommunity.loadMore': 'Mehr laden',
  'backoffice.myCommunity.expand': 'Erweitern',
  'backoffice.myCommunity.collapse': 'Zusammenklappen',
  'backoffice.myCommunity.resetView': 'Ansicht zurücksetzen',
  'backoffice.myCommunity.memberSince': 'Mitglied seit',
  'backoffice.myCommunity.comingSoon': 'Demnächst verfügbar...',

  // Tree specific
  'backoffice.myCommunity.directReferrals': 'Direkte Empfehlungen',
  'backoffice.myCommunity.treeLevel': 'Baumebene',
  'backoffice.myCommunity.zoomIn': 'Vergrößern',
  'backoffice.myCommunity.zoomOut': 'Verkleinern',
  
  // Members specific
  'backoffice.myCommunity.totalUsers': 'Gesamte Benutzer',
  'backoffice.myCommunity.activeUsers': 'Aktive Benutzer',
  'backoffice.myCommunity.inactiveUsers': 'Inaktive Benutzer',
  'backoffice.myCommunity.levelStats': 'Ebene {level} Statistiken',
  'backoffice.myCommunity.yourProfile': 'Ihr Profil',
  'backoffice.myCommunity.communityMembers': 'Community-Mitglieder',
  
  // Filters
  'backoffice.myCommunity.filterByLevel': 'Nach Ebene filtern',
  'backoffice.myCommunity.filterByStatus': 'Nach Status filtern',
  'backoffice.myCommunity.allLevels': 'Alle Ebenen',
  'backoffice.myCommunity.allStatuses': 'Alle Status',
  
  // Error messages
  'backoffice.myCommunity.noDataFound': 'Keine Community-Daten gefunden',
  'backoffice.myCommunity.errorLoading': 'Fehler beim Laden der Community-Daten',
  'backoffice.myCommunity.tryAgain': 'Erneut versuchen',

  // Table column headers - updated keys
  'backoffice.myCommunity.tableColumns.username': 'Benutzername',
  'backoffice.myCommunity.tableColumns.name': 'Name',
  'backoffice.myCommunity.tableColumns.status': 'Status',
  'backoffice.myCommunity.tableColumns.rank': 'Rang',
  'backoffice.myCommunity.tableColumns.level': 'Ebene',
  'backoffice.myCommunity.tableColumns.joinDate': 'Beitrittsdatum',
  'backoffice.myCommunity.tableColumns.country': 'Land',
};
